
.quoteWrapper {

  position: relative;
  background: var(--beigedark);
  border-radius: 100px;
  padding: 24px;

  // give room below for the overlapping badge
  &:has(.badge) {
    margin-bottom: 110px;
  }

  .badge {
    position: absolute;
    left: -90px;
    bottom: -140px;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background: var(--beigedarker);
    color: var(--beigelight);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: .75em;
    padding: 1.5em;
  }

  .quote {
    //padding: 10em;

    font-style: italic;
    font-size: 1.15em; // 15% bigger
    line-height: 1.5;
    margin: 0;
    text-align: center;
    font-weight: 300;
    //color: var(--beigedarker);


    &::before {
      font-family: serif;
      font-style: italic;
      color: var(--beigedarker);
      text-align: left;
      content: '\201c';
      font-size: 200px;
      display: block;
      line-height: 20px;
    }

  }


  .author {
    font-weight: bold;
    font-style: normal;
    text-align: center;

    &::before {
      content: "\2014\0020"; // long dash + space

    }
  }
}